import React, { Component } from 'react';
import { Form, Select, AutoComplete } from 'antd';
import PropTypes from 'prop-types';
import { getDataList_box } from '@/api/api';

// const Option = Select.Option;
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;

class Combobox extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            dataBox: [],
        }
    }

    componentDidMount() {
        const that = this;
        const { feild, setValue, type } = this.props;
        //typeId:必填，10-设备品牌，12-设备存放地，3-获取试剂耗材存放地,6-获取试剂耗材品牌,7-获取试剂耗材单位,8-获取试剂耗材分类,9-供应商
        //labFlag:选填，是否取本实验室数据
        //name:选填，模糊查询名称
        getDataList_box({ typeId: type, labFlag: 1 }, res => {// 设备品牌
            console.log(res);
            if (res.statusCode === 1000) {
                let dataBox = res.objList.map(opt => {
                    return (
                        <Option key={opt.id} value={opt.id.toString()}>
                            {opt.name}
                        </Option>
                    )
                });

                that.setState({
                    dataBox: dataBox
                })
            }
        }, err => {
            console.log(err)
        })
    }

    render() {
        const { setValue, feildArr, initialValue, width } = this.props;
        const { dataBox } = this.state;
        return (
            <AutoComplete
                getPopupContainer={triggerNode => triggerNode.parentNode}
                dataSource={dataBox}
                style={{ width: width ? width : "240px" }}
                optionLabelProp='children'
                onChange={(value) => {
                    console.log(value)
                    setValue(feildArr[0], value)
                }}
                onSelect={(value, option) => {
                    console.log(option)
                    setValue(feildArr[1], value)
                }}
                defaultValue={initialValue ? initialValue : ''}
                placeholder="请选择"
            />
            // <Select 
            // style={{width:width ? width : "240px"}}
            // mode="combobox"
            // initialValue={initialValue ? initialValue :''}
            // optionLabelProp='children'
            // onChange={(value)=>{
            //     setValue(feildArr[0],value)
            // }}
            // onSelect={(value,option)=>{
            //     setValue(feildArr[1],value)
            // }}
            // >
            //     {dataBox.map(x=>{
            //         return(
            //             <Option value={x.id.toString()} key={x.id.toString()}>{x.name}</Option>
            //         )
            //     })}
            // </Select>
        )
    }
}

Combobox.propTypes = {
    type: PropTypes.number.isRequired,
    setValue: PropTypes.func.isRequired,
    feildArr: PropTypes.array.isRequired,
}

export default Combobox
